import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-checkbox", {
    attrs: {
      checked: _vm.checkAll
    },
    on: {
      change: _vm.onChangeAll
    }
  }, [_vm._v(_vm._s(_vm.checkAll ? _vm.$t("取消全选") : _vm.$t("全选")))]), _vm.data.length > 0 ? _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      columns: _vm.columns,
      "data-source": _vm.data,
      bordered: "",
      pagination: false,
      rowKey: "id",
      defaultExpandAllRows: true
    },
    scopedSlots: _vm._u([{
      key: "menu",
      fn: function (text) {
        return [_vm._v(_vm._s(_vm.$t(text)))];
      }
    }, {
      key: "expandedRowRender",
      fn: function (record, i) {
        return _c("div", {
          staticStyle: {
            margin: "0"
          }
        }, _vm._l(record.list, function (item, index) {
          var _item$permissionsGrou, _item$permissionsGrou2;
          return _c("div", {
            key: index,
            style: record.list.length - 1 != index ? "margin-bottom:20px" : ""
          }, [_c("div", {
            staticClass: "name"
          }, [_vm._v(" " + _vm._s(_vm.$t(item.name)) + " "), item.remark ? _c("span", [_vm._v("--" + _vm._s(_vm.$t(item.remark)))]) : _vm._e(), item.selected ? _c("span", {
            on: {
              click: function ($event) {
                return _vm.configureFun(item.allowField, i, index);
              }
            }
          }, [_vm._v(_vm._s(_vm.$t("字段配置")))]) : _vm._e(), _c("span", [_vm.customerDesensitizes && _vm.customerDesensitizes.length > 0 && _vm.type === "customerRole" ? [item.selected && _vm.customerDesensitizes.includes(item.permissionsGroup.find(item2 => item2.associationId == 0).id) && item.name !== "首页" && item.name != "数据看板" && item.permissionsGroup.length > 0 ? _c("a-checkbox", {
            attrs: {
              checked: item === null || item === void 0 || (_item$permissionsGrou = item.permissionsGroup.find(item2 => item2.associationId == 0)) === null || _item$permissionsGrou === void 0 ? void 0 : _item$permissionsGrou.desensitize
            },
            on: {
              change: function ($event) {
                return _vm.desensitizeChange(item, $event);
              }
            }
          }, [_vm._v(" " + _vm._s(_vm.$t("取消脱敏")) + " ")]) : _vm._e()] : _vm._e(), _vm.type === "customer" || _vm.type === "role" ? [item.selected && item.name !== "首页" && item.name != "数据看板" && item.permissionsGroup.length > 0 ? _c("a-checkbox", {
            attrs: {
              checked: item === null || item === void 0 || (_item$permissionsGrou2 = item.permissionsGroup.find(item2 => item2.associationId == 0)) === null || _item$permissionsGrou2 === void 0 ? void 0 : _item$permissionsGrou2.desensitize
            },
            on: {
              change: function ($event) {
                return _vm.desensitizeChange(item, $event);
              }
            }
          }, [_vm._v(" " + _vm._s(_vm.$t("取消脱敏")) + " ")]) : _vm._e()] : _vm._e()], 2)]), _c("div", [_c("a-checkbox", {
            attrs: {
              checked: item.allSelected
            },
            on: {
              change: function ($event) {
                return _vm.change2(i, item);
              }
            }
          }, [_vm._v(_vm._s(_vm.$t("全部")))]), _vm._l(item.permissionsGroup, function (item2, index2) {
            return _c("a-checkbox", {
              key: index2,
              attrs: {
                checked: item2.selected
              },
              on: {
                change: function ($event) {
                  return _vm.onChange(item2, record, index);
                }
              }
            }, [_c("a-tooltip", {
              attrs: {
                placement: "top"
              }
            }, [_c("template", {
              slot: "title"
            }, [_c("span", [_vm._v(_vm._s(_vm.$t(item2.description)))])]), _vm._v(" " + _vm._s(_vm.$t(item2.name)) + " ")], 2)], 1);
          })], 2)]);
        }), 0);
      }
    }], null, false, 3515148597)
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0) : _vm._e(), _c("a-button", {
    staticClass: "marginT20",
    staticStyle: {
      width: "200px",
      "margin-left": "40%"
    },
    attrs: {
      type: "add"
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("确认")))]), _vm.fieldConfigurationShow ? _c("field-configuration-model", {
    ref: "fieldConfiguration",
    on: {
      cancel: function ($event) {
        _vm.fieldConfigurationShow = false;
      },
      ok: _vm.handleSure
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };